const SELECTOR = 'select.select-tabs';

class ComboTab {
  constructor() {
    if ($(SELECTOR).size()) {
      $(':selected', $(SELECTOR)).tab('show'); //to show the tab when validation error occurs
      $(SELECTOR).on('change', function() {
        $(':selected', this).tab('show');
      });
    }
  }
}

export default ComboTab;



// WEBPACK FOOTER //
// ./src/javascripts/ComboTab.js